// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","138":"profile","594":"demo"}[chunkId] || chunkId) + "-legacy." + {"94":"031db0b0","138":"2938b746","594":"05bcde67","827":"212bc6bc"}[chunkId] + ".js";
};